const ReversalStatusBanner = ({ isReversal = false, isReversed = false, reversedText, reversalText }) => {
  if (!isReversal && !isReversed) return null

  const isEntry = Boolean(isReversal)
  const text = isEntry
    ? (reversalText || "This row is a reversal entry posted to offset a previous transaction.")
    : (reversedText || "This record has been reversed and no longer affects balances or summary totals.")

  return (
    <div
      className={`rounded-3 px-3 py-2 mb-3 ${isEntry ? "border border-info-subtle bg-info-subtle" : "border border-secondary-subtle bg-light"}`}
    >
      <div className={`small fw-semibold ${isEntry ? "text-info-emphasis" : "text-secondary"}`}>
        {isEntry ? "Reversal Entry" : "Reversed"}
      </div>
      <div className="small text-dark">{text}</div>
    </div>
  )
}

export default ReversalStatusBanner
